var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15.101,
    viewBox: "0 0 14 15.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12563",
    "data-name": "Group 12563",
    transform: "translate(-97.424 -865.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10143",
    "data-name": "Group 10143",
    transform: "translate(97.424 867.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2607",
    "data-name": "Ellipse 2607",
    fill: "#6f7070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "I",
    transform: "translate(5.601 10.899)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i"))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2607-2",
    "data-name": "Ellipse 2607",
    transform: "translate(97.424 867.031)",
    fill: "#6f7070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "I-2",
    "data-name": "I",
    transform: "translate(103.024 877.931)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconGrey);
export default __webpack_public_path__ + "static/media/Info-icon-grey.e7d0f221.svg";
export { ForwardRef as ReactComponent };